function employeeReport() {
	return {
		agents: [],

		init() {
            this.loadEmployees();
        },
		loadEmployees() {
            axios.get(`/api/reports/employees?fromDate=` + fromDate + '&toDate=' + toDate).then(response => {
            	this.agents = response.data.agents;
            });
        },
		filterDate($event) {
        	this.loadEmployees();
        }
	}
}

export default employeeReport;
